import { useEffect, useState } from "react";
import { CheckBox } from "../../components/checkBox/CheckBox";
import { TextField } from "../../components/fields/Fields";
import { SelectFields } from "../../components/select/SelectFields";
import Button from "../../components/button/Button";
import { CheckBoxItem } from "../../components/checkBox/CheckBoxGroup";
import FormController from "../../components/fields/FormController";
import { useForm } from "react-hook-form";
import { Messages, SearchMessage, getMessageSearchData} from "../../model/Message";
import { Company } from "../../model/Companies";
import { ReplyButton } from "../../model/ReplyButton";
import { Groups } from "../../model/Groups";
import userQuery from "../../firestore/User.query";
import authApi from "../../api/Auth.api";
import { auth } from "../../firebase";
import { MagnifyingGlassIcon, ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/24/outline";
import { GroupSelectModal } from "../userList/GroupSelectModal";
import Badge from "../../components/badges/Badges";
import { useDispatch } from "react-redux";
import { AlertValue, alertOpen } from "../../features/alert.slice";
import { ConstMessage } from "../../config/const";
import messagesQuery from "../../firestore/Messages.query";
import { requestRdbMessageAuthorUserList } from "../../api/Messages.api";
import { Staff } from "../../model/Staff";
import jwtApi from "../../api/Jwt.api";

type Props = {
  groupList: Groups[];
  replyButtonList: ReplyButton[];
  company: Company | undefined;
  checkedValue: string;
  setCheckedValue: React.Dispatch<React.SetStateAction<string>>;
  checkedDate: string;
  setCheckedDate: React.Dispatch<React.SetStateAction<string>>;
  searchMessageItem: SearchMessage;
  setSearchMessageItem: React.Dispatch<React.SetStateAction<SearchMessage>>;
  onSearch: (searchCondition: any) => void;
};

export const MessageSearch = ({
  groupList,
  replyButtonList,
  company,
  checkedValue,
  setCheckedValue,
  checkedDate,
  setCheckedDate,
  searchMessageItem,
  setSearchMessageItem,
  onSearch
}:Props) => {

  // ログイン中の団体管理者情報
  const currentUser = auth.currentUser;
  const dispatch = useDispatch();

  const [searchFlg, setSearchFlg] = useState(true);
  const [replyButtonsList, setReplyButtonsList] = useState([]);
  const [eventTypeList, setEventTypeList] = useState([]);
  const [authorList, setAuthorList] = useState([]);
  const [isOpenGroupSelect, setIsOpenGroupSelect] = useState(false);
  const [isVoid, setIsVoid] = useState(false);
  const [defaultGroups, setDefaultGroups] = useState<CheckBoxItem[]>([]);
  const [companyGroupsValue, setCompanyGroupsValue] = useState<CheckBoxItem[]>([]);
  const [selectedGroups, setSelectedGroups] = useState<CheckBoxItem[]>([]);

  const { control } = useForm<Messages & {select: string, topicLength: number, tokenLength: number}>({});

  // アイコン設定
  const searchIcon = {icon: MagnifyingGlassIcon};
  const upIcon = {icon: ChevronUpIcon};
  const downIcon = {icon: ChevronDownIcon};

  // 初期表示
  useEffect(() => {
    const f = async () => {
      try{
        // イベントタイププルダウン
        let eventTypesList:any = [{id:"", name:""}];
        company?.eventType!.map((type:string) => {
          eventTypesList.push({id: type, name:type});
        })
        setEventTypeList(eventTypesList);
        // 作成者プルダウン
        let adminList:any = [{id:"", name:""}];
        const authors = await authApi.requestGetStaff(currentUser?.tenantId!);
        if (authors.success) {
          const staffList = authors.data.filter((item: Staff) => item.email !== undefined)
          staffList.map((item: Staff) => adminList.push({id:item.displayName, name:item.displayName}))
        } else {
          throw new Error(authors.data);
        }
        const adminUser = await requestRdbMessageAuthorUserList(currentUser?.tenantId!);
        adminUser.map((item:{author_uid: string, last_name: string}) => adminList.push({id:item.last_name, name:item.last_name}));
        setAuthorList(adminList);
      }catch(err: any){
        dispatch(alertOpen(AlertValue(ConstMessage.ERR_FAILED_GET_DATA, "danger")));
      }
    };
    f();
  },[]);

  // 初期表示
  useEffect(() => {
    const f = async () => {
      try{
        // 返信ボタンプルダウン
        let replyButtonsList:any = [
          {id:"", name:""},
          {id:"＜未設定＞", name:"＜未設定＞"},
          {id:"", name:"予定表", disabled:true},
          {id:"予定表の出欠(オンライン)", name:"　予定表の出欠(オンライン)"},
          {id:"予定表の出欠", name:"　予定表の出欠"},
          {id:"", name:"お知らせ", disabled:true},
        ];
        replyButtonList.map((replyButton) => {
          if(replyButton.id !== "undefined"){
            replyButtonsList.push({id:replyButton.name, name:"　"+ replyButton.name});
          }
        })
        setReplyButtonsList(replyButtonsList)
      }catch(err: any){
        dispatch(alertOpen(AlertValue(ConstMessage.ERR_FAILED_GET_DATA, "danger")));
      }
    };
    f();
  },[replyButtonList]);

  // 初期表示
  useEffect(() => {
    const f = async () => {
      try{
        // グループセレクト画面
        if (defaultGroups.length > 0) return;

        const defaultGroupsValue = groupList ?
          groupList.map((item): CheckBoxItem => {
            return {
              id: item.id,
              title: item.name,
              value: false,
              disabled: item.deleteFlg,
            }
          })
        : [];
        setDefaultGroups(defaultGroupsValue)
        setCompanyGroupsValue(defaultGroupsValue);
        setSelectedGroups(defaultGroupsValue);
      }catch(err: any){
        dispatch(alertOpen(AlertValue(ConstMessage.ERR_FAILED_GET_DATA, "danger")));
      }
    };
    f();
  },[groupList]);

  // 検索画面の表示・非表示の切り替え
  const handleClick = (e:any) => {
    e.preventDefault();
    setSearchFlg(searchFlg? false : true);
  };

  //チェックボックス（textフォーム）の値を管理
  const changedCheckBox = (e:any, value:string) => {
    setSearchMessageItem({...searchMessageItem, title: "", contactInformation: ""});
    setCheckedValue(value);
  }

  //チェックボックス（日付フォーム）の値を管理
  const changedDateCheckBox = (e:any, value:string) => {
    setSearchMessageItem(
      {...searchMessageItem, 
        sendDateStart:"", sendDateEnd:"", publishEndAtStart:"", publishEndAtEnd:"", eventAtStart:"", eventAtEnd:""
      }
    );
    setCheckedDate(value);
  }

  // 検索を実行
  const onClickSearch = async () => {
    onSearch(getMessageSearchData(searchMessageItem, checkedValue, checkedDate));
  };

  const selectList = 
    [
      {id:"", name:""},
      {id:company?.displayId, name:"全体"},
      {id:"topic", name:"グループ"},
      {id:"token", name:"個別"}
    ];

  const publishList = 
    [
      {id:"", name:""},
      {id:"message", name:"お知らせのみ"},
      {id:"schedule", name:"予定表のみ"},
    ];

  const statusList = 
    [
      {id:"", name:""},
      {id:"draft", name:"下書き"},
      {id:"undeliverd", name:"未配信"},
      {id:"deliverd", name:"配信済み"},
      {id:"publishEnd", name:"掲載終了"},
    ];

  // グループセレクト画面の表示用
  useEffect(() => {
    const f = async () => {
      setIsVoid(!isVoid);
      if(companyGroupsValue.length > 0){
        let topic: any = [];
        await Promise.all(companyGroupsValue.map((item: any) => {
          if(item.value){
            const value = item.value;
            topic.push({id:item.id, title: item.title});
          }
        }));
        setSearchMessageItem({...searchMessageItem, topic:topic});
      }
    };
    f();
  },[isOpenGroupSelect]);

  const toggle = () => {
    setSelectedGroups(companyGroupsValue);
    setIsOpenGroupSelect(!isOpenGroupSelect);
    setIsVoid(!isVoid);
  };

  const onSelectCancel = () => {
    // 変更前のグループ選択状態をセット
    setCompanyGroupsValue(selectedGroups);
    setSearchMessageItem({...searchMessageItem, topic: []});
    setIsOpenGroupSelect(!isOpenGroupSelect);
    setIsVoid(!isVoid);
  }

  /** 検索する配信先の変更 */
  const onchangePublishTarget = (select: string) => {
    if(select !== "topic"){
      // グループの選択状態をリセットする
      setCompanyGroupsValue(defaultGroups);
      setSelectedGroups(defaultGroups);
    }
  };
    
    return(
      <div className="flex flex-col">
        <div className="">
          <div className="inline-block min-w-full p-1 align-middle">
            <div className="relative overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
              <table className="min-w-full table-fixed divide-y">
                <div className="sm:items-center p-2">
                  <div className="flex justify-between cursor-pointer" onClick={(e) => handleClick(e)}>
                    <h2 className=" flex font-semibold text-gray-900 items-center">
                      <searchIcon.icon
                        className={"flex-shrink-0 h-5 w-5"}
                        aria-hidden="true"
                      />
                      検索
                    </h2>
                    {searchFlg?(
                      <>
                        <upIcon.icon
                        className={"flex-shrink-0 h-5 w-5"}
                        aria-hidden="true"
                        />
                      </>
                    ):(
                      <>
                        <downIcon.icon
                        className={"flex-shrink-0 h-5 w-5"}
                        aria-hidden="true"
                        />
                      </>
                    )}
                  </div>
                  {searchFlg?(
                    <>
                      <h3 className="text-sm text-gray-500 mb-1">&nbsp;複数項目を入力した場合はAND検索となります</h3>
                      <div className="flex">
                        <div className="w-3/10 min-w-[390px]">
                          <div className="relative overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg ">
                            <table className="table-fixed ">
                              <div className="sm:items-center p-2">
                                <h3 className="text-sm text-gray-500 mr-2 mb-1 ml-2">前方一致検索 ※いずれか１つの項目を選択してください</h3>
                                <div className="flex items-center justify-center">
                                  <h3 className="text-sm text-gray-900">タイトル　　</h3>&nbsp;
                                  <CheckBox
                                    id="title"
                                    value={checkedValue == "title" ? true : false}
                                    onChange={(e:any) => changedCheckBox(e, checkedValue == "title"? "" : "title")}
                                  />
                                  <div className="w-1/10">
                                  <TextField
                                    id=""
                                    className={'h-10 w-44'}
                                    inputClassName={`${checkedValue == "title" ? "" : "bg-gray-300"} h-8`}
                                    value={searchMessageItem.title}
                                    disabled={checkedValue == "title" ? false : true}
                                    onChange={(e:any) => setSearchMessageItem({...searchMessageItem, title:e.target.value})}
                                  />
                                  </div>
                                </div>
                                <div className="flex items-center justify-center">
                                  <h3 className="text-sm text-gray-900">問い合わせ先</h3>&nbsp;
                                  <CheckBox
                                    id="contactInformation"
                                    value={checkedValue == "contactInformation" ? true : false}
                                    onChange={(e:any) => changedCheckBox(e, checkedValue == "contactInformation"? "" : "contactInformation")}
                                  />
                                  <div className="w-1/10">
                                  <TextField
                                    id=""
                                    className={'h-10 w-44'}
                                    inputClassName={`${checkedValue == "contactInformation" ? "" : "bg-gray-300"} h-8`}
                                    value={searchMessageItem.contactInformation}
                                    disabled={checkedValue == "contactInformation" ? false : true}
                                    onChange={(e:any) => setSearchMessageItem({...searchMessageItem, contactInformation:e.target.value})}
                                  />
                                  </div>
                                </div>
                              </div>
                            </table>
                          </div>
                          <div className="flex items-center justify-center my-1 w-3/10">
                            <h3 className="text-sm text-gray-900">配信先</h3>&nbsp;
                            <SelectFields
                              id="select"
                              color="indigo"
                              value={searchMessageItem.select}
                              className={"ml-10 h-10 w-52"}
                              selectItems={selectList}
                              onChange={(e:any) => {
                                setSearchMessageItem({...searchMessageItem, select:e.target.value, topic: []})
                                onchangePublishTarget(e.target.value);
                              }}
                            />
                          </div>
                          {searchMessageItem.select == "topic"? 
                          <>
                            <div className="flex w-3/10">
                              <div className={`text-left items-start`}>
                                <div className="h-12 w-full min-w-[280px] border-2 border-solid overflow-y-scroll">
                                  {searchMessageItem.topic.map(
                                    (item: any, index) => (
                                      
                                      <Badge
                                        color="blue"
                                      >
                                        {item.title}
                                      </Badge>
                                  ))}
                                </div>
                              </div>
                              <Button
                                className={"h-12 w-24 ml-4 pl-4 pr-4 text-sm items-center rounded-full"}
                                onClick={toggle}
                                children={"グループ選択"}
                              />
                            </div>
                            <h3 className="text-xs text-gray-500 ">複数選択した場合いずれかに配信するお知らせすべてが検索されます</h3>
                            <GroupSelectModal
                              open={isOpenGroupSelect}
                              toggle={toggle}
                              closeOnClickOutside
                              companyGroupsValue={companyGroupsValue}
                              setState={setCompanyGroupsValue}
                              children={undefined}
                              dispButtonFlg={true}
                              onSelectCancel={onSelectCancel}
                            />
                          </>
                          :
                          <></>
                          }
                          
                        </div>
                        <div className="ml-8 w-3/10">
                          <div className="relative overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                            <table className={`table-fixed `}>
                              <div className="sm:items-center p-2">
                                <h3 className="text-sm text-gray-500 mb-1 ml-2">いずれか１つの項目を選択してください</h3>
                                <div className="flex sm:items-center justify-start flex-wrap">
                                  <h3 className="text-sm text-gray-900">配信日　　　　</h3>&nbsp;
                                  <div className="flex items-center w-2/10">
                                  <CheckBox
                                    id="sendDate"
                                    value={checkedDate == "sendDate" ? true : false}
                                    onChange={(e:any) => changedDateCheckBox(e, checkedDate == "sendDate"? "" : "sendDate")}
                                  />
                                  <FormController
                                    control={control}
                                    value={searchMessageItem.sendDateStart}
                                    className={"h-10"}
                                    inputClassName={`${checkedDate == "sendDate" ? "" : "bg-gray-300"} h-8`}
                                    name={"sendDate_s"}
                                    label={""}
                                    onChange={(e:any) => setSearchMessageItem({...searchMessageItem, sendDateStart: e.target.value})}
                                    type={"date"}
                                    disabled={checkedDate == "sendDate" ? false : true}
                                  />
                                  ～
                                  <FormController
                                    control={control}
                                    value={searchMessageItem.sendDateEnd}
                                    className={"h-10"}
                                    inputClassName={`${checkedDate == "sendDate" ? "" : "bg-gray-300"} h-8`}
                                    name={"sendDate_e"}
                                    label={""}
                                    onChange={(e:any) => setSearchMessageItem({...searchMessageItem, sendDateEnd: e.target.value})}
                                    type={"date"}
                                    disabled={checkedDate == "sendDate" ? false : true}
                                  />
                                  </div>
                                </div>
                                <div className="flex sm:items-center justify-start flex-wrap">
                                  <h3 className="text-sm text-gray-900">掲載終了日　　</h3>&nbsp;
                                  <div className="flex items-center w-2/10">
                                  <CheckBox
                                    id="publishEndAt"
                                    value={checkedDate == "publishEndAt" ? true : false}
                                    onChange={(e:any) => changedDateCheckBox(e, checkedDate == "publishEndAt"? "" : "publishEndAt")}
                                  />
                                  <FormController
                                    control={control}
                                    value={searchMessageItem.publishEndAtStart}
                                    className={"h-10"}
                                    inputClassName={`${checkedDate == "publishEndAt" ? "" : "bg-gray-300"} h-8`}
                                    name={"publishEndAt_s"}
                                    label={""}
                                    onChange={(e:any) => setSearchMessageItem({...searchMessageItem, publishEndAtStart: e.target.value})}
                                    type={"date"}
                                    disabled={checkedDate == "publishEndAt" ? false : true}
                                  />
                                  ～
                                  <FormController
                                    control={control}
                                    value={searchMessageItem.publishEndAtEnd}
                                    className={"h-10"}
                                    inputClassName={`${checkedDate == "publishEndAt" ? "" : "bg-gray-300"} h-8`}
                                    name={"publishEndAt_e"}
                                    label={""}
                                    onChange={(e:any) => setSearchMessageItem({...searchMessageItem, publishEndAtEnd: e.target.value})}
                                    type={"date"}
                                    disabled={checkedDate == "publishEndAt" ? false : true}
                                  />
                                  </div>
                                </div>
                                <div className="flex sm:items-center justify-start flex-wrap">
                                  <h3 className="text-sm text-gray-900">イベント開催日</h3>&nbsp;
                                  <div className="flex items-center w-2/10">
                                  <CheckBox
                                    id="eventAt"
                                    value={checkedDate == "eventAt" ? true : false}
                                    onChange={(e:any) => changedDateCheckBox(e, checkedDate == "eventAt"? "" : "eventAt")}
                                  />
                                  <FormController
                                    control={control}
                                    value={searchMessageItem.eventAtStart}
                                    className={"h-10"}
                                    inputClassName={`${checkedDate == "eventAt" ? "" : "bg-gray-300"} h-8`}
                                    name={"eventAt_s"}
                                    label={""}
                                    onChange={(e:any) => setSearchMessageItem({...searchMessageItem, eventAtStart: e.target.value})}
                                    type={"date"}
                                    disabled={checkedDate == "eventAt" ? false : true}
                                  />
                                  ～
                                  <FormController
                                    control={control}
                                    value={searchMessageItem.eventAtEnd}
                                    className={"h-10"}
                                    inputClassName={`${checkedDate == "eventAt" ? "" : "bg-gray-300"} h-8`}
                                    name={"eventAt_e"}
                                    label={""}
                                    onChange={(e:any) => setSearchMessageItem({...searchMessageItem, eventAtEnd: e.target.value})}
                                    type={"date"}
                                    disabled={checkedDate == "eventAt" ? false : true}
                                  />
                                  </div>
                                </div>
                              </div>
                            </table>
                          </div>  
                        </div>
                        <div className="ml-8 mt-8 w-2/10">
                          <div className="flex sm:items-center justify-start flex-1 flex-wrap">
                            <h3 className="text-sm text-gray-900">掲載先　　</h3>&nbsp;
                            <div className="w-1/10">
                              <SelectFields
                                id="eventFlg"
                                color="indigo"
                                value={searchMessageItem.eventFlg}
                                className={"h-10 w-48"}
                                selectItems={publishList}
                                onChange={(e:any) => setSearchMessageItem({...searchMessageItem, eventFlg:e.target.value})}
                              />
                            </div>
                          </div>
                          <div className="flex sm:items-center justify-start flex-1 flex-wrap">
                            <h3 className="text-sm text-gray-900">ステータス</h3>&nbsp;
                            <div className="w-1/10">
                            <SelectFields
                              id="status"
                              color="indigo"
                              value={searchMessageItem.status}
                              className={"h-10 w-48"}
                              selectItems={statusList}
                              onChange={(e:any) => setSearchMessageItem({...searchMessageItem, status:e.target.value})}
                            />
                            </div>
                          </div>
                          <div className="flex sm:items-center justify-start flex-1 flex-wrap">
                            <h3 className="text-sm text-gray-900">返信ボタン</h3>&nbsp;
                            <div className="w-1/10">
                            <SelectFields
                              id="replyButton"
                              color="indigo"
                              value={searchMessageItem.replyButton}
                              className={"h-10 w-48"}
                              selectItems={replyButtonsList}
                              onChange={(e:any) => setSearchMessageItem({...searchMessageItem, replyButton:e.target.value})}
                            />
                            </div>
                          </div>
                        </div>
                        <div className="ml-6 mt-8 w-2/10">
                          <div className="flex sm:items-center justify-start flex-wrap">
                            <h3 className="text-sm text-gray-900">イベントタイプ</h3>&nbsp;
                            <div className="w-1/10">
                            <SelectFields
                              id="eventType"
                              color="indigo"
                              value={searchMessageItem.eventType}
                              className={"h-10 w-44"}
                              selectItems={eventTypeList}
                              onChange={(e:any) => setSearchMessageItem({...searchMessageItem, eventType:e.target.value})}
                            />
                            </div>
                          </div>
                          <div className="flex sm:items-center justify-start flex-wrap">
                            <h3 className="text-sm text-gray-900">作成者　　　　</h3>&nbsp;
                            <div className="w-1/10">
                            <SelectFields
                              id="authorName"
                              color="indigo"
                              value={searchMessageItem.authorName}
                              className={"h-10 w-44"}
                              selectItems={authorList}
                              onChange={(e:any) => setSearchMessageItem({...searchMessageItem, authorName:e.target.value})}
                            />
                            </div>
                          </div>
                          <div className={`flex sm:items-center justify-end ${searchMessageItem.select == "topic"? "mt-14 mb-2" : "mt-10 mb-2"} mr-1`}>
                            <Button
                              className={"mt-2 h-10 w-32 text-sm sm:items-center"}
                              onClick={onClickSearch}
                              children={"検索"}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  ):(
                    <>
                    </>
                  )}
                  
                </div>
              </table>
            </div>
          </div>
        </div>
      </div>
    )
};